export default __webpack_public_path__ + "static/media/784.5393392a.gif";